<template>
  <section class="scroll-mt-[var(--ui-header-height)]">
    <UContainer>
      <h2 class="text-4xl text-center text-primary font-bold">Fotogalerie</h2>
      <p class="text-center text-xl my-4">
        Tady najdete fotky naší práce, když si vzpomenem ji sem nahrát.
      </p>

      <div class="flex flex-wrap w-full gap-4 gap-y-8 justify-around">
        <BlogCard v-for="post of blogPosts" :key="post.uuid" :post="post" />
      </div>
    </UContainer>
  </section>
</template>

<script lang="ts" setup>
const client = useStoryblokApi();
const { data } = await client.getStories({
  by_slugs: "*",
});
const blogPosts = data.stories;
</script>
<style></style>
